import { render, staticRenderFns } from "./MyPortalsList.vue?vue&type=template&id=21c41c96&scoped=true&"
import script from "./MyPortalsList.vue?vue&type=script&lang=js&"
export * from "./MyPortalsList.vue?vue&type=script&lang=js&"
import style0 from "./MyPortalsList.vue?vue&type=style&index=0&id=21c41c96&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21c41c96",
  null
  
)

export default component.exports